import React, { Fragment } from 'react'
import SVG from "react-inlinesvg";
import { maxScore, totalScore, timeSpent } from '@app/helpers/studentsHelper'
import Results from '@app/components/students/Tasks/Results'
import Restart from '@app/containers/students/Start/Restart'
import BonusTask from '@app/containers/students/BonusTask'
import { Can } from '@app/context/ability-context'
import cupIcon from '@src/images/student-tasks/cup';
import _ from 'lodash'

const TimeSpent = ({ objects }) => {
  const time = timeSpent(objects) || 0;

  return (
    <p className="f--default f--bold f--l">
      {
        I18n.t('students.results_time', {
          minutes: Math.floor(time / 60),
          seconds: time % 60
        })
      }
    </p>
  )
}

const Content = ({ student, statistics, className }) => {
  const objects = _.values(statistics.objects)

  return (
    <Fragment>
      <Can I="read correctAnswer" of="Score" passThrough>
        {
          can => can ? (
            <div className="student-tasks-page__results-block-rewards">
              Your Score for Each Task <br/>
              <span>
                Use eye button to see correct answer
              </span>
            </div>
          ) : (
            <div className="student-tasks-page__results-block">
              <div className="student-tasks-page__results-banner-outer">
                <div className="student-tasks-page__results-banner">
                  <div className="student-tasks-page__results-banner-icon">
                    <SVG src={cupIcon}/>
                  </div>
                  <p>
                    {
                      I18n.t('students.results', {
                        total: totalScore(objects),
                        max: maxScore(objects)
                      })
                    }
                    <br/> Well done!
                  </p>
                </div>
              </div>
              <div className="student-tasks-page__results-hint">
                Your Score for Each Task
              </div>
            </div>
          )
        }
      </Can>
      <Results student={student} className={className} statistics={statistics}/>
      <Can I="read correctAnswer" of="Score" passThrough>
        {
          can => can ? (
            <div className="student-tasks-page__bonus-wrapper">
              <BonusTask student={student}/>
            </div>
          ) : null
        }
      </Can>
    </Fragment>
  )
}

export default Content
